export default __webpack_public_path__ + "static/media/pagamentos.89476e65.svg";